<template>
  <div>
    <el-row
      type="flex"
      justify="center"
      class="payment-bank-modal--table-header"
    >
      <el-col :span="1">
        <el-checkbox
          v-model="checkAll"
          :indeterminate="isIndeterminate"
          @change="handleCheckAllChange"
        />
      </el-col>
      <el-col :span="3"> Погрузка </el-col>
      <el-col :span="8"> Направление </el-col>
      <el-col :span="4"> Номер авто </el-col>
      <el-col :span="4"> Перевозчик </el-col>
      <el-col :span="4"> Номер платежа </el-col>
    </el-row>
    <el-row v-for="response in responses" :key="response.id">
      <el-checkbox-group v-model="checked" @change="handleCheckedCitiesChange">
        <el-row
          v-for="payment in response.payments"
          :key="payment.id"
          class="payment-bank-modal--table-body"
          type="flex"
        >
          <el-col :span="1">
            <el-checkbox :key="payment.id" :label="payment.id" />
          </el-col>
          <el-col :span="3">
            {{ dateToFormat(response.date_loaded, 'shortDateWithoutYear') }}
          </el-col>
          <el-col :span="8">
            {{ loadLocationFilter(response.bid) }}<br />
            {{ response.organization.short_name }} на
            {{ response.bid.cargo_receiver_name }}
          </el-col>
          <el-col :span="4">
            {{ response.auto.state_numbers_trailer }}<br />
            {{ response.auto.state_numbers }}
          </el-col>
          <el-col :span="4">
            {{ response.organization.short_name }}
          </el-col>
          <el-col :span="4">
            <payment-number :item="payment" />
          </el-col>
        </el-row>
      </el-checkbox-group>
    </el-row>
    <span slot="footer" class="dialog-footer">
      <el-button type="primary" @click="putNumberPaymentsHandler">
        Проставить номер
      </el-button>
      <el-button type="primary" @click="unloadingBank">
        Выгрузить в банк
      </el-button>
    </span>
  </div>
</template>

<script>
import { RepositoryFactory } from '@/api/RepositoryFactory'
import PaymentNumber from './Column/PaymentNumber'
import shippingMixin from '@/mixins/shippingMixin'

const paymentsApi = RepositoryFactory.get('payments')
const documentApi = RepositoryFactory.get('doc')

export default {
  name: 'Items',
  components: { PaymentNumber },
  mixins: [shippingMixin],
  props: {
    responses: {
      type: Array,
      default: () => [],
    },
    payments: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      checkAll: false,
      checked: [],
      isIndeterminate: true,
    }
  },
  methods: {
    handleCheckAllChange(val) {
      this.checked = val ? this.payments.map(e => e.id) : []
      this.isIndeterminate = false
    },
    handleCheckedCitiesChange(value) {
      let checkedCount = value.length

      this.checkAll = checkedCount === this.payments.length
      this.isIndeterminate =
        checkedCount > 0 && checkedCount < this.payments.length
    },
    async putNumberPaymentsHandler() {
      let checkedPayments = this.getCheckedPayments()

      if (checkedPayments.length) {
        checkedPayments = this.setNumberPayments(checkedPayments)
      }

      const res = checkedPayments.map(payment =>
        paymentsApi.update(payment.id, {
          payment_number: payment.payment_number,
        }),
      )

      await Promise.all(res)
    },
    setNumberPayments(payments) {
      return payments.reduce((previousValue, currentValue) => {
        if (previousValue.length) {
          currentValue.payment_number =
            Number(
              previousValue[previousValue.length - 1].payment_number || 0,
            ) + 1
        }

        return [...(previousValue || []), currentValue]
      }, [])
    },
    getCheckedPayments() {
      return this.payments.filter(payment => this.checked.includes(payment.id))
    },
    async unloadingBank() {
      const checkedPayments = this.getCheckedPayments()

      await documentApi
        .unloadingBank(checkedPayments)
        .then(response => {
          const optionDate = {
            year: 'numeric',
            month: 'numeric',
            day: 'numeric',
          }

          this.forceFileDownload(
            response,
            `выгрузка в банк ${new Date().toLocaleString(
              'ru',
              optionDate,
            )}.txt`,
          )
        })
        .catch(e => console.log('e', e))
    },
  },
}
</script>
